function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.547 29l-7.212-3.796L3.123 29V10.655h14.424V29z",
  fill: "#C92128"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.955 18.878c-4.934 0-8.856-4.048-8.856-8.856 0-4.934 4.048-8.856 8.856-8.856s8.856 4.048 8.856 8.856c.127 4.808-3.922 8.856-8.856 8.856z",
  fill: "#C5CAD5"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.066 16.684A7.464 7.464 0 106.767 3.15a7.464 7.464 0 006.3 13.535z",
  fill: "#BDC1C6"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.43,
  fill: "#B1B9CC"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.43,
  d: "M14.383 3.823L5.147 15.589c.253.127.38.38.633.506l9.236-11.766c-.253-.127-.506-.38-.633-.506zM15.902 5.34L6.919 16.729c.126 0 .253.126.38.126l8.856-11.26c-.127 0-.127-.127-.253-.253zM12.612 2.937L3.756 14.071c.126.126.126.253.253.38L12.99 3.063c-.126 0-.252-.127-.379-.127zM10.588 2.431L2.87 12.173c.127.253.127.506.253.633L11.347 2.43c-.253.126-.506 0-.76 0z"
}));
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.123 9.896c0-4.049 3.163-7.339 7.212-7.465-4.302-.127-7.845 3.29-7.845 7.465 0 4.301 3.543 7.59 7.845 7.464-4.049-.126-7.212-3.416-7.212-7.464z",
  fill: "#8B99AD"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.596 19.5a9.615 9.615 0 009.345-9.879 9.615 9.615 0 10-19.223.534 9.615 9.615 0 009.878 9.345z",
  fill: "#D3D9E5"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M10.335 16.728a6.832 6.832 0 100-13.664 6.832 6.832 0 000 13.664z",
  fill: "#CBD1DD"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M10.335 16.348a6.453 6.453 0 100-12.905 6.453 6.453 0 000 12.905z",
  fill: "#BDC6D1"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M10.335 15.842a5.946 5.946 0 100-11.893 5.946 5.946 0 000 11.893z",
  fill: "#C1C6D2"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.738 15.336L5.653 6.353c-.253.38-.506.633-.632 1.012l6.579 8.35 1.138-.379zM9.323 15.716l-4.935-6.2v.886l4.049 5.06c.253.254.633.254.886.254zM14.763 13.818l-7.212-9.11c-.126.127-.38.127-.506.253l7.338 9.236.38-.38zM16.028 11.414l-5.82-7.338c-.38 0-.632 0-1.012.126l6.453 8.224c.126-.38.253-.76.38-1.012z",
  fill: "#B5BAC6"
});
function SvgSilver(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}
export default SvgSilver;